module.exports = __webpack_public_path__ + "img/free_multiplier_6.fff6d3e1.png";